module.exports = __webpack_public_path__ + "docs/template-examples-1.5.zip";